// import {
//   ChangePassword,
// } from "./Pages/Common";
import {
  Dashboard as ClientDashboard,
  Sensor as ClientSensor,
  Reports as ClientReports,
  Alerts as ClientAlerts,
} from "./Pages/Client";

/* import $ from 'jquery';

window.jQuery = $;
window.$ = $;
global.jQuery = $; */

//const OtherSamplePage = React.lazy(() => import('./Demo/Other/SamplePage'));

const routes = [
  // {
  //   path: "/sample-page",
  //   exact: true,
  //   name: "Sample Page",
  //   component: <OtherSamplePage
  // },
  {
    path: "/dashboard",
    exact: true,
    name: "Dashboard",
    component: <ClientDashboard />,
  },
  {
    path: "/sensor/:id",
    exact: true,
    name: "Sensor",
    component: <ClientSensor />,
  },
  {
    path: "/reports",
    exact: true,
    name: "Reports",
    component: <ClientReports />,
  },
  {
    path: "/alerts",
    exact: true,
    name: "Alerts",
    component: <ClientAlerts />,
  },
];

export default routes;
